module.exports = __webpack_public_path__ + "img/driver2.117b80ff.jpeg";